export const Order = {
   CREATED:'CREATED',
   QUOTED: 'QUOTED',
   PRE_PAID: 'PRE_PAID',
   PAID: 'PAID',
   SENT: 'SENT',
   DELIVERED: 'DELIVERED',
   REJECTED: 'REJECTED',
};
